import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { addPhoto } from '../redux/userSlice';
import { useHistory } from 'react-router-dom';

const PhotoForm = ({ handleAddPhoto, handleAddUserPhoto, formShow }) => {

    const history = useHistory();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user.user)

    const [image, setImage] = useState(null)
    const [camera, setCamera] = useState("")
    const [aperture, setAperture] = useState("")
    const [shutter_speed, setShutter_Speed] = useState("")
    const [iso, setIso] = useState("")
    const [lens, setLens] = useState("")
    const [location, setLocation] = useState("")
    const [time, setTime] = useState("")
    const [category, setCategory] = useState("")
    const [weather, setWeather] = useState("")
    const [notes, setNotes] = useState("")
    // const [imgData, setImgData] = useState(null);

    // const [formData, setFormData] = useState({
    //     image: null,
    //     camera: "",
    //     aperture: "",
    //     shutter_speed: "",
    //     iso: "",
    //     lens: "",
    //     location: "",
    //     time: "",
    //     category: "",
    //     weather: "",
    //     notes: ""
    //   })

    //   const handleChange = (event) => {
    //     setFormData({
    //       ...formData,
    //       [event.target.name]: event.target.value,
    //     });
    //   }

      // const onImageChange = (e) => {
      //   if (e.target.files[0]) {
      //       console.log("picture: ", e.target.files);
      //       setImage(e.target.files[0]);
      //       const reader = new FileReader();
      //       reader.addEventListener("load", () => {
      //         setImgData(reader.result);
      //       });
      //       reader.readAsDataURL(e.target.files[0]);
      //     }
      //   };

      const handleSubmit = (event) => {
        event.preventDefault();
        const formData = {
            ownerId: parseInt(user.id),
            image: image,
            camera: camera,
            aperture: aperture,
            shutter_speed: shutter_speed,
            iso: iso,
            lens: lens,
            location: location,
            time: time,
            category: category,
            weather: weather,
            notes: notes,
        };
        
        fetch("https://fotoset.herokuapp.com/photos", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
        .then((r) => r.json())
        .then(data => {
            handleAddUserPhoto(data)
            handleAddPhoto(data)
            dispatch(addPhoto(data))
            history.push("/");
        });
      }

    return(
    <div className={`${formShow ? "active" : ""} show`}>
          <div className="photo-form">
                    <h3>New Photo</h3>
            <form id="new-photo-form" onSubmit={handleSubmit}>
                <label className="label-name">Image Url: </label>
                <br/>
                <input type="text" id="image" className="input-box" accept="image/*" placeholder="Photo url..."onChange={(e) => setImage(e.target.value)}required/>
                <br/>
                {/* <div className="previewProfilePic">
                    <img className="playerProfilePic_home_tile" src={imgData} alt="preview"/>
                </div> */}
                <label className="label-name">Camera Name: </label>
                <br/>
                <input type="text" className="input-box" name="camera" placeholder="Camera name..." value={camera} onChange={(e) => setCamera(e.target.value)} required/>
                <br/>
                <label className="label-name">Aperture: </label>
                <br/>
                <input type="text" className="input-box" name="aperture" placeholder="Aperture..." value={aperture} onChange={(e) => setAperture(e.target.value)}required/>
                <br/>
                <label className="label-name">Shutter Speed: </label>
                <br/>
                <input type="text" className="input-box" name="shutter_speed" placeholder="Shutter Speed..." value={shutter_speed} onChange={(e) => setShutter_Speed(e.target.value)} required/>
                <br/>
                <label className="label-name">ISO: </label>
                <br/>
                <input type="text" className="input-box" name="iso" placeholder="ISO..." value={iso} onChange={(e) => setIso(e.target.value)} required/>
                <br/>
                <label className="label-name">Camera Lens: </label>
                <br/>
                <input type="text" className="input-box" name="lens" placeholder="Camera lens..." value={lens} onChange={(e) => setLens(e.target.value)} required/>
                <br/>
                <label className="label-name">Location: </label>
                <br/>
                <input type="text" className="input-box" name="location" placeholder="Location..." value={location} onChange={(e) => setLocation(e.target.value)} required/>
                <br/>
                <label className="label-name">Date/Time: </label>
                <br/>
                <input type="text" className="input-box" name="time" placeholder="Time..." value={time} onChange={(e) => setTime(e.target.value)} required/>
                <br/>
                <label className="label-name">Category: </label>
                <br/>
                <select className="input-box" name="category" id="category" form="new-photo-form" value={category} onChange={(e) => setCategory(e.target.value)} required>
                            <option value="">Choose a category</option>
                            <option value="Cityscape">Cityscape</option>
                            <option value="Landscape">Landscape</option>
                            <option value="Street">Street</option>
                            <option value="Aerial">Nature</option>
                            <option value="Sport">Sport</option>
                            <option value="Portrait">Portrait</option>
                            <option value="Wildlife">Wildlife</option>
                            <option value="Food">Food</option>
                            <option value="others">Others</option>
                </select>
                <br/>
                <label className="label-name">Weather: </label>
                <br/>
                <input type="text" className="input-box" name="weather" placeholder="Weather..." value={weather} onChange={(e) => setWeather(e.target.value)} required/>
                <br/>
                <label className="label-name">Notes: </label>
                <br/>
                <textarea type="text" className="input-area" name="notes" placeholder="Notes..." value={notes} onChange={(e) => setNotes(e.target.value)} required/>
                <button type="submit" className="add-photo-btn">Add Photo</button>
                <br/>
            </form>
        </div> 
      </div>
    )
}

export default PhotoForm;
